<template>
<div class="warp">
    <div :class="navIdx == item.id?'icon seicon':'icon'" v-for="item in icons" :key="item.id" @click="selectNav(item)">
        <img :src="item.img" alt="">
        {{item.bar}}
    </div>
    <div class="toolbar">
        <div :class="barIdx == item.tid?'bars selected':'bars' " v-for="item in bars" :key="item.tid" :title="item.bar" @click.stop="selectMenu(item)">
            <img :src="item.img" alt="">
            <div class="list" v-if="item.list">
                <div class="view" v-for="item2 in item.list" :title="item2.bar" :key="item2.nid" @click.stop="selectMenu(item2)">
                    <img :src="item2.img" alt="">
                </div>
            </div>
            
        </div>
    </div>
    <div class="viewsee" v-show="iSetView">
        <div class="viewText">
            视点管理
            <span @click="iSetView = false">x</span>
        </div>
        <div class="con">
            <div class="createView">
                <div class="btn" @click="createView">创建视点</div>
            </div>
            <div class="viewArr">
                <div class="item" v-for="(item,index) in viewArr" :key="item.id" @click.stop="fly(item.fly)">
                    <div class="text">
                        <img src="../../assets/img/ViewOperation.png" alt="">
                        {{item.name}}
                    </div>
                    <i class="el-icon-delete" @click="removeView(index)"></i>
                </div>
            </div>
        </div>
    </div>
</div>
    
</template>

<script>
import Draw from '../viewer/js/draw'

import url from '../../assets/img/water.jpg'
export default {
    data(){
        return {
            url,
            primitiveArr:[],  // primitive类
            icons:[
                {
                    id:1,
                    bar:"视图管理",
                    falg:false,
                    img:require('../../assets/img/ViewOperation.png'),
                    bars:[
                        {
                            tid:1,
                            bar:"主视图",
                            falg:false,
                            img:require('../../assets/img/MainView.png'),
                        },
                        {
                            tid:2,
                            bar:"视角管理",
                            falg:false,
                            img:require('../../assets/img/SubTransparency.png'),
                            list:[
                                {
                                    nid:1,
                                    bar:'前视角',
                                    img:require('../../assets/img/FrontView.png'),
                                },
                                {
                                    nid:2,
                                    bar:'后视角',
                                    img:require('../../assets/img/RearView.png'),
                                },
                                {
                                    nid:3,
                                    bar:'左视角',
                                    img:require('../../assets/img/LeftView.png'),
                                },
                                {
                                    nid:4,
                                    bar:'右视角',
                                    img:require('../../assets/img/RightView.png'),
                                },
                                {
                                    nid:5,
                                    bar:'顶视角',
                                    img:require('../../assets/img/TopView.png'),
                                },
                            ]
                        },
                        {
                            tid:3,
                            bar:"视点设置",
                            falg:false,
                            img:require('../../assets/img/SubCameraManage.png'),
                        },
                    ]
                },
                {
                    id:2,
                    bar:"场景操作",
                    falg:false,
                    img:require('../../assets/img/SceneOperation.png'),
                    bars:[
                        {
                            tid:1,
                            bar:"测量工具",
                            falg:false,
                            img:require('../../assets/img/MeasurementOperation.png'),
                            list:[
                                {
                                    nid:1,
                                    bar:'测量距离',
                                    img:require('../../assets/img/SubDistance.png'),
                                },
                                {
                                    nid:2,
                                    bar:'测量面积',
                                    img:require('../../assets/img/SubArea.png'),
                                },
                                {
                                    nid:3,
                                    bar:'清除测量结果',
                                    img:require('../../assets/img/SubClear.png'),
                                },
                            ]
                        },
                    ]
                },
                {
                    id:3,
                    bar:"构件操作",
                    falg:false,
                    img:require('../../assets/img/FeatureAction.png'),
                    bars:[
                        {
                            tid:1,
                            bar:"构件信息",
                            falg:false,
                            img:require('../../assets/img/SubAttributes.png'),
                        },
                        {
                            tid:2,
                            bar:"构件隐藏",
                            falg:false,
                            img:require('../../assets/img/SubHideOrShow.png'),
                        },
                        {
                            tid:3,
                            bar:"裁切",
                            falg:false,
                            img:require('../../assets/img/ComponentPlaning.png'),
                            list:[
                                {
                                    nid:1,
                                    bar:'x轴裁切',
                                    img:require('../../assets/img/SubCut.png'),
                                },
                                {
                                    nid:2,
                                    bar:'y轴裁切',
                                    img:require('../../assets/img/SubCut.png'),
                                },
                                {
                                    nid:3,
                                    bar:'z轴裁切',
                                    img:require('../../assets/img/SubCut.png'),
                                },
                            ]
                        },
                    ]
                },
            ],
            bars:[],
            navIdx:0,
            viewArr:[],
            iSetView:false,
            barIdx:0,
            handler:null,
            draw:new Draw(),
            pointEntyArr:[],  // 点位集合
            positionArr:[],  // 点位坐标集合
            linesArr:[], // 线段集合
            distance:0 , // 线长度 
            areaPointsArr:[],//面积点位集合
            areaPositions:[], // 面积位置集合
            areaLines:[], // 面积线集合
            areaPolygon:[], // 面积多边形
            areaPolygonPositions:[], //多边形点位数组
            polygon:null, // 画出的多边形
        }
    },
    mounted(){
        this.selectNav(this.icons[0])
    },
    methods:{
        selectNav(nav){
            this.navIdx = nav.id
            this.bars = nav.bars
            this.barIdx = 0
            this.removeViewcss()
            this.removeDraw()
            this.removeFatrue()
        },
        removeViewcss(){
            this.iSetView = false
        },
        removeDraw(){
            this.remove()
        },
        removeFatrue(){
            this.$emit('removefature')
        },
        selectMenu(menu){
            this.removeViewcss()
            this.removeDraw()
            this.removeFatrue()
            this.barIdx = menu.tid
            let _this = this
            switch(menu.bar){
                case '主视图': 
                    _this.$emit('selectMenu', menu)
                    break;
                case '前视角': 
                    _this.$emit('selectMenu', menu)
                    break;
                case '后视角': 
                    _this.$emit('selectMenu', menu)
                    break;
                case '左视角': 
                    _this.$emit('selectMenu', menu)
                    break;
                case '右视角': 
                    _this.$emit('selectMenu', menu)
                    break;
                case '顶视角': 
                    _this.$emit('selectMenu', menu)
                    break;
                case '视点设置': 
                    _this.iSetView = true
                    break;
                case '测量距离': 
                    _this.initHandler()
                    break;
                case '测量面积': 
                    _this.getArea()
                    break;
                case '清除测量结果': 
                    _this.remove()
                    break;
                case '构件信息': 
                    _this.$emit('selectMenu', menu)
                    break;
                case '构件隐藏': 
                    _this.$emit('selectMenu', menu)
                    break;
                case 'x轴裁切': 
                    _this.$emit('selectMenu', menu)
                    break;
                case 'y轴裁切': 
                    _this.$emit('selectMenu', menu)
                    break;
                case 'z轴裁切': 
                    _this.$emit('selectMenu', menu)
                    break;
            }
        },
        reset(menu){
            let _this = this
            this.bars.forEach(item =>{
                if(item.bar !== menu.bar){
                    item.falg = false
                    this.$emit('selectMenu', item)
                }
            })
            this.removeWater()
            _this.quit()
        },
        freeden(){
            let ellipsoid = viewer.scene.globe.ellipsoid;

            viewer.scene.screenSpaceCameraController.enableRotate = false;
            viewer.scene.screenSpaceCameraController.enableTranslate = false;
            viewer.scene.screenSpaceCameraController.enableZoom = false;
            viewer.scene.screenSpaceCameraController.enableTilt = false;
            viewer.scene.screenSpaceCameraController.enableLook = false;

            let startMousePosition;
            let mousePosition;
            let flags = {
                looking : false,
                moveForward : false,
                moveBackward : false,
                moveUp : false,
                moveDown : false,
                moveLeft : false,
                moveRight : false
            };

            viewer.screenSpaceEventHandler.setInputAction(function(movement) {
                flags.looking = true;
                mousePosition = startMousePosition = Cesium.Cartesian3.clone(movement.position);
            }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

            viewer.screenSpaceEventHandler.setInputAction(function(movement) {
                mousePosition = movement.endPosition;
            }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

            viewer.screenSpaceEventHandler.setInputAction(function(position) {
                flags.looking = false;
            }, Cesium.ScreenSpaceEventType.LEFT_UP);

            function getFlagForKeyCode(keyCode) {
                switch (keyCode) {
                case 'W'.charCodeAt(0):
                    return 'moveForward';
                case 'S'.charCodeAt(0):
                    return 'moveBackward';
                case 'Q'.charCodeAt(0):
                    return 'moveUp';
                case 'E'.charCodeAt(0):
                    return 'moveDown';
                case 'D'.charCodeAt(0):
                    return 'moveRight';
                case 'A'.charCodeAt(0):
                    return 'moveLeft';
                default:
                    return undefined;
                }
            }

            document.addEventListener('keydown', this.down = function(e){
                let flagName = getFlagForKeyCode(e.keyCode);
                if (typeof flagName !== 'undefined') {
                    flags[flagName] = true;
                }
            }, false);

            document.addEventListener('keyup', this.up =(e)=>{
                let flagName = getFlagForKeyCode(e.keyCode);
                if (typeof flagName !== 'undefined') {
                    flags[flagName] = false;
                }
            }, false);

            viewer.clock.onTick.addEventListener(function(clock) {
                let camera = viewer.camera;
                // 镜头旋转
                if (flags.looking) {
                    let width = viewer.canvas.clientWidth;
                    let height = viewer.canvas.clientHeight;

                    let lookFactor =0.1;
                    let x = (mousePosition.x - startMousePosition.x) / width;
                    let y = -(mousePosition.y - startMousePosition.y) / height;
                    
                    camera.setView({
                        orientation: {
                            heading : camera.heading + x*lookFactor, 
                            pitch : camera.pitch + y*lookFactor,    
                            roll : 0.0                             
                        }
                    })
                }

                // 根据高度来决定镜头移动的速度
                var cameraHeight = ellipsoid.cartesianToCartographic(camera.position).height;
                var moveRate = cameraHeight / 150.0;

                if (flags.moveForward) {
                    camera.moveForward(moveRate);
                }
                if (flags.moveBackward) {
                    camera.moveBackward(moveRate);
                }
                if (flags.moveUp) {
                    camera.moveUp(moveRate);
                }
                if (flags.moveDown) {
                    camera.moveDown(moveRate);
                }
                if (flags.moveLeft) {
                    camera.moveLeft(moveRate);
                }
                if (flags.moveRight) {
                    camera.moveRight(moveRate);
                }
            });
        },
        quit(){
            viewer.scene.screenSpaceCameraController.enableRotate = true;
            viewer.scene.screenSpaceCameraController.enableTranslate = true;
            viewer.scene.screenSpaceCameraController.enableZoom = true;
            viewer.scene.screenSpaceCameraController.enableTilt = true;
            viewer.scene.screenSpaceCameraController.enableLook = true;
            viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN)
            viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE)
            viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP)
            document.removeEventListener('keydown',this.down,false)
            document.removeEventListener('keyup',this.up,false)
        },
        addWater(){
            let _this = this
            let water = viewer.scene.primitives.add(
                new Cesium.Primitive({
                    geometryInstances: new Cesium.GeometryInstance({
                        geometry: new Cesium.RectangleGeometry({
                            rectangle: Cesium.Rectangle.fromDegrees(
                                110.16,20.14,
                                110.18,20.16,
                            ),
                            vertexFormat: Cesium.EllipsoidSurfaceAppearance.VERTEX_FORMAT,
                        }),
                    }),
                    appearance: new Cesium.EllipsoidSurfaceAppearance({
                        material: new Cesium.Material({
                            fabric: {
                                type: "Water",
                                uniforms: {
                                    baseWaterColor: new Cesium.Color(64 / 255.0, 157 / 255.0, 253 / 255.0, 0.5),
                                    normalMap: _this.url,
                                    frequency: 1000.0,
                                    animationSpeed: 0.1,
                                    amplitude: 10,
                                    specularIntensity: 10
                                }
                            }
                        })
                    }),
                })
            );
            this.primitiveArr.push(water)
            convenient.fly({
                x: -2065927.3455220475,
                y: 5623692.337816107,
                z: 2182677.079521227,
                heading:6.178072730801672,
                pitch:-0.9225404997113462,
                roll:3.3735822757563483e-7
            })
        },
        removeWater(){
            if(this.primitiveArr.length > 0){
                this.primitiveArr.forEach(item =>{
                    viewer.scene.primitives.remove(item)
                })
            }
            
        },
        createView(){
            let car3 = viewer.camera
            let obj = {
                id:this.viewArr.length +1,
                name:'视图'+ (this.viewArr.length +1),
                fly:{
                    x:car3.position.x,
                    y:car3.position.y,
                    z:car3.position.z,
                    heading:car3.heading,
                    pitch:car3.pitch,
                    roll:car3.roll
                }
            }

            this.viewArr.push(obj)
        },
        fly(fly){
            convenient.fly(fly)
        },
        removeView(idx){
            this.viewArr.splice(idx,1)
        },
        initHandler(){
            let _this = this
            this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
            this.handler.setInputAction((moment)=>{
                
                let position = convenient._getDegreesByCartesian3(viewer.scene.pickPosition(moment.position))
                
                _this.positionArr.push(position)
                
                if(_this.pointEntyArr.length >= 1){
                    let line = _this.drawLine({positions:[_this.positionArr[_this.positionArr.length - 2].lon,_this.positionArr[_this.positionArr.length - 2].lat, _this.positionArr[_this.positionArr.length - 2].alt, _this.positionArr[_this.positionArr.length - 1].lon, _this.positionArr[_this.positionArr.length - 1].lat, _this.positionArr[_this.positionArr.length - 1].alt]})
                    _this.linesArr.push(line)
                    let distance = _this.getDistance(_this.positionArr[_this.positionArr.length - 2], _this.positionArr[_this.positionArr.length - 1])
                    console.log(distance);
                    _this.distance += Number(distance)
                    
                }
                
                let point = _this.drawPoint({position, text:_this.distance.toFixed(2) + 'm'})
                _this.pointEntyArr.push(point)

            }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
        },
        getArea(){
            let _this = this 
            this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
            this.handler.setInputAction((moment)=>{
                
                //拿到点击的屏幕坐标转经纬度
                let position = convenient._getDegreesByCartesian3(viewer.scene.pickPosition(moment.position))
                _this.areaPositions.push(position)

                _this.areaPolygonPositions.push(position.lon, position.lat, position.alt)
                console.log(_this.areaPolygonPositions);

                // 在位置添加点
                let point = _this.draw.addPoint({position, labelShow:false})
                _this.areaPointsArr.push(point)

                // 画出两个点之间的线
                if(_this.areaPositions.length > 1){
                    let line = _this.draw.addLine({name:"面积线", positions:[
                        _this.areaPositions[_this.areaPositions.length - 2].lon, 
                        _this.areaPositions[_this.areaPositions.length - 2].lat,
                        _this.areaPositions[_this.areaPositions.length - 2].alt,
                        _this.areaPositions[_this.areaPositions.length - 1].lon, 
                        _this.areaPositions[_this.areaPositions.length - 1].lat,
                        _this.areaPositions[_this.areaPositions.length - 1].alt,
                    ]})
                    _this.areaLines.push(line)
                }

                

            },Cesium.ScreenSpaceEventType.LEFT_CLICK)

            // 右键结束画出面积 
            this.handler.setInputAction((moment)=>{
                // 画出面积
                if(_this.areaPositions.length > 2){
                    // 先闭合最后一条线
                    let line = _this.draw.addLine({name:"面积线", positions:[
                        _this.areaPositions[0].lon, 
                        _this.areaPositions[0].lat,
                        _this.areaPositions[0].alt,
                        _this.areaPositions[_this.areaPositions.length - 1].lon, 
                        _this.areaPositions[_this.areaPositions.length - 1].lat,
                        _this.areaPositions[_this.areaPositions.length - 1].alt,
                    ]})
                    _this.areaLines.push(line)

                    // 添加区域多边形
                    let polygon = _this.draw.addPlane({name:"面积", plane:_this.areaPolygonPositions})
                    _this.areaPolygon.push(polygon)

                    let polyPositions = polygon._polygon._hierarchy.getValue(Cesium.JulianDate.now()).positions;
                    let polyCenter = Cesium.BoundingSphere.fromPoints(polyPositions).center;//中心点
                    polyCenter = Cesium.Ellipsoid.WGS84.scaleToGeodeticSurface(polyCenter)
                    
                    let degrees = convenient._getDegreesByCartesian3(polyCenter)
                    
                    let area = _this.getPolygonArea(_this.areaPositions)
                    // console.log(area);

                    let label = _this.draw.addLabel({text:Number(area).toFixed(2) + ' 平方米', position:{lon:degrees.lon, lat:degrees.lat, alt:_this.areaPositions[0].alt}})
                    // let label = _this.draw.addLabel({text:Number(area).toFixed(2) + ' 平方米', position:degrees})
                    _this.areaPointsArr.push(label)

                    _this.handler.destroy()
                    _this.handler = null
                }
            },Cesium.ScreenSpaceEventType.RIGHT_CLICK)
        },
        remove(){
            if(this.pointEntyArr.length >0){
                this.pointEntyArr.forEach(item =>{
                    viewer.entities.remove(item)
                })
                this.pointEntyArr = []
            }
            
            if(this.linesArr.length > 0){
                this.linesArr.forEach(item =>{
                    viewer.entities.remove(item)
                })
                this.linesArr = []
            }
            
            if(this.areaLines.length > 0){
                this.areaLines.forEach(item =>{
                    viewer.entities.remove(item)
                })
                this.areaLines = []
            }

            if(this.areaPointsArr.length > 0){
                this.areaPointsArr.forEach(item =>{
                    viewer.entities.remove(item)
                })
                this.areaPointsArr = []
            }

            if(this.areaPolygon.length > 0){
                this.areaPolygon.forEach(item =>{
                    viewer.entities.remove(item)
                })
                this.areaPolygon = []
            }

            this.areaPolygonPositions = []
            this.areaPositions = []
            this.distance = 0
            this.positionArr = []
            if(this.handler){
                this.handler.destroy()
                this.handler = null
            }
            
        },
        drawPoint(params){
            let point = this.draw.addPoint(params)
            return point
        },
        drawLine(params){
            let line = this.draw.addLine(params)
            return line
        },
        getDistance(start, end){
            let startp = Cesium.Cartographic.fromDegrees(start.lon, start.lat, start.alt)
            let endp = Cesium.Cartographic.fromDegrees(end.lon, end.lat, end.alt)

            let geodesic = new Cesium.EllipsoidGeodesic()
            geodesic.setEndPoints(startp, endp) 
            return geodesic.surfaceDistance 
        },
        getPolygonArea(positions){
            let _this = this
            let area = 0

            for(let i = 0;i <positions.length - 2;i++){
                let angle = _this.getAngel(positions[i], positions[i+ 1], positions[i + 2])
                let distance1 = _this.getDistance(positions[i + 1], positions[0])
                let distance2 = _this.getDistance(positions[i + 2], positions[0])

                area += distance1 * distance2 * Math.sin(angle) / 2
            }

            return  Math.abs(area)
        },
        getAngel(point1, point2, point3){
            let bearing21 = this.Bearing(point2, point1)
            let bearing23 = this.Bearing(point2, point3)
            let angle = bearing21 - bearing23
            if (angle < 0) {
                angle += Math.PI * 2.0
            }
            return angle
        },
        // 方向
        Bearing (from, to) {
            console.log(from, to);
            let fromCartographic = Cesium.Cartographic.fromDegrees(from.lon, from.lat, from.alt)
            let toCartographic = Cesium.Cartographic.fromDegrees(to.lon, to.lat, to.alt)
            let lat1 = fromCartographic.latitude
            let lon1 = fromCartographic.longitude
            let lat2 = toCartographic.latitude
            let lon2 = toCartographic.longitude
            let angle = -Math.atan2(Math.sin(lon1 - lon2) * Math.cos(lat2), Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon1 - lon2))
            if (angle < 0) {
                angle += Math.PI * 2.0
            }
            return angle
        },
    }
}
</script>

<style lang="less" scoped>
.warp{
    position: fixed;
    bottom:0;
    left:0;
    top: 0;
    margin: auto;
    width: 4vw;
    height: 30vh;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    background-color: #3f3e3c99;
    border-radius: 8px;
    .icon{
        width: 4vw;
        height: 8vh;
        display: flex;
        color: #b0b1b5;
        font-size: 14px;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        &>img{
            width: 40%;
            height: 40%;
        }

        &:hover{
            background-color: #16171b;
            border-radius: 5px;
        }
    }
    .seicon{
        background-color: #16171b;
        border-radius: 5px;
    }
    
}
    .toolbar{
        position: fixed;
        bottom:2vh;
        height:5vh;
        max-width: 10vw;
        left: 0;
        right: 0;
        margin: auto;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        background-color: rgba(0,0,0,.8);
        border: 0.1rem solid #706f6d;
        border-radius: 8px;


        .bars{
            width: 3vw;
            height: 5vh;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            &>img{
                width: 25px;
                height: 25px;
            }
            .list{
                position: absolute;
                bottom: 5vh;
                left: 0;
                display: none;
                background-color: rgba(0,0,0,.8);
                border-radius: 8px;
                .view{
                    width: 3vw;
                    height: 5vh;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    &>img{
                        width: 25px;
                        height: 25px;
                    }
                    &:hover {
                        background-color: #3f3e3c;
                        border-radius: 5px;
                    }
                }
            }
            &:hover .list{
                display: block;
            }

            &:hover {
                background-color: #3f3e3c;
                border-radius: 5px;
            }
        }
        .selected{
            background-color: #3f3e3c;
            border-radius: 5px;
        }
    }

    .viewsee{
        position: fixed;
        right: 1vw;
        top: 17vh;
        width: 13.5vw;
        // min-height: 15vh;
        background-color: #3f3e3cCC ;
        // opacity: 0.8;
        .viewText{
            height:4vh ;
            line-height: 4vh;
            padding:0 1vw ;
            font-size: 14px;
            color: #fff ;
            border-bottom: 1px solid #f0f0f0;
            position: relative;
            &>span{
                position: absolute;
                right: 1vw;
                top: 0vh;
                transform: scale(1.5);
                cursor: pointer;
            }
        }
        .con{
            background-color: rgba(45, 33, 33, 0.75);
            min-height: 10vh;
            color: #fff;
            .createView{
                height: 4vh;
                padding: 0.5vw;
                .btn{
                    height: 2.5vh;
                    width: 25%;
                    font-size: 12px;
                    line-height: 2.5vh;
                    text-align: center;
                    padding: 0 0.5vw;
                    border: 1px solid rgba(221, 221, 221, 0.45);
                    border-radius: 5px;
                }
                
            }
            .viewArr{
                padding: 0 0.3vw;
                .item{
                    height: 5vh;
                    font-size: 12px;
                    padding: 0 0.3vw;
                    box-sizing: border-box;
                    border-top: 1px dashed rgba(221, 221, 221, 0.45);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .text{
                        &>img{
                            width: 1vw;
                            height: 2vh;
                            vertical-align: middle;
                            margin-right: 0.5vw;
                        }
                    }
                }
                .item:nth-child(1){
                    border-top:1px solid rgba(221, 221, 221, 0.45) ;
                }
            }
        }
    }
</style>